import { render } from "./AddEditCompanyBoardItem.vue?vue&type=template&id=daaa4430&ts=true"
import script from "./AddEditCompanyBoardItem.vue?vue&type=script&lang=ts"
export * from "./AddEditCompanyBoardItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__